import { useCallback, useRef, useState } from 'react';
import type { KeyboardEvent, TouchEvent } from 'react';

export function useSampleCarousel(count: number) {
  const [current, setCurrent] = useState(0);
  const start = useRef<{ x: number; y: number } | null>(null);

  const showSample = useCallback(
    (index: number) => setCurrent(((index % count) + count) % count),
    [count]
  );

  const next = () => showSample(current + 1);
  const prev = () => showSample(current - 1);

  const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      showSample(current + (event.key === 'ArrowRight' ? 1 : -1));
    }
  };

  const onTouchStart = (event: TouchEvent<HTMLDivElement>) => {
    if (event.touches.length === 1) {
      start.current = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }
  };

  const onTouchEnd = (event: TouchEvent<HTMLDivElement>) => {
    if (!start.current) return;
    const dx = event.changedTouches[0].clientX - start.current.x;
    const dy = event.changedTouches[0].clientY - start.current.y;
    if (Math.abs(dx) > 65 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      showSample(current + (dx < 0 ? 1 : -1));
    }
    start.current = null;
  };

  return { current, showSample, next, prev, onKeyDown, onTouchStart, onTouchEnd };
}
